
import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if consent has already been granted
    const consentGranted = localStorage.getItem('consentGranted');
    if (!consentGranted) {
      setShowBanner(true);
      // Small delay for smooth animation
      setTimeout(() => setIsVisible(true), 100);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('consentGranted', 'true');
    
    // Grant consent for Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        ad_storage: 'granted',
        analytics_storage: 'granted'
      });
    }

    // Hide banner with animation
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  const handleDecline = () => {
    localStorage.setItem('consentGranted', 'false');
    
    // Deny consent for Google Analytics
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ad_storage: 'denied',
        analytics_storage: 'denied'
      });
    }

    // Hide banner with animation
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  if (!showBanner) return null;

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
      <div className="bg-gray-900 text-white border-t-2 border-orange-500 shadow-xl">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
            <div className="flex-1">
              <div className="flex items-center mb-2">
                <i className="ri-shield-check-line text-orange-500 text-xl mr-2"></i>
                <h3 className="font-semibold text-lg">Protection de vos données</h3>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed">
                Nous utilisons des cookies et Google Analytics pour améliorer votre expérience sur notre site FMS Protec. 
                Ces outils nous aident à analyser le trafic et à optimiser nos services de sécurité en Belgique. 
                Vous pouvez accepter ou refuser leur utilisation.
              </p>
            </div>
            
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={handleDecline}
                className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors cursor-pointer text-sm font-medium whitespace-nowrap"
              >
                <i className="ri-close-line mr-1"></i>
                Refuser
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2 bg-gradient-to-r from-orange-500 to-blue-500 hover:from-orange-600 hover:to-blue-600 text-white rounded-lg transition-all cursor-pointer text-sm font-medium whitespace-nowrap shadow-lg"
              >
                <i className="ri-check-line mr-1"></i>
                Accepter les cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
